import { motion } from 'framer-motion'
import { Handshake, Target, Layers, Heart, Users } from 'lucide-react'

const values = [
  { icon: Handshake, title: 'Win-Win Partnerships', text: 'We believe business relationships should create value for everyone involved. Our success is directly tied to the success of our clients.' },
  { icon: Target, title: 'Impact Over Noise', text: 'We focus on strategies that move the business forward, not activities that simply look impressive.' },
  { icon: Layers, title: 'Simplicity In Execution', text: 'Complex strategies often fail in real-world execution. We believe in building clear and simple systems that deliver results.' },
  { icon: Heart, title: 'Respectful Collaboration', text: 'Every client relationship is built on transparency, communication, and mutual respect.' },
  { icon: Users, title: 'People Over Pressure', text: 'We believe sustainable growth comes from healthy teams and balanced partnerships. We prioritize clarity and well-being over burnout.' },
]

export function WhyChooseUs() {
  return (
    <section className="section-pad px-4 sm:px-6 lg:px-8 bg-white dark:bg-navy-900 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] light-orb light-orb-primary opacity-20 dark:opacity-0 pointer-events-none" aria-hidden />
      <div className="container-wide relative">
        <motion.h2
          className="section-heading text-center mb-10 sm:mb-14"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Why Businesses Choose DigiSutra
        </motion.h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {values.slice(0, 3).map((v, i) => (
            <motion.div
              key={v.title}
              className="group card-glass p-6 sm:p-8 relative overflow-hidden"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              whileHover={{ y: -6 }}
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-accent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <motion.div
                whileHover={{ scale: 1.1 }}
                transition={{ type: 'spring', stiffness: 400 }}
              >
                <v.icon className="text-primary dark:text-accent" size={28} strokeWidth={1.8} />
              </motion.div>
              <h3 className="mt-4 font-semibold text-slate-800 dark:text-slate-100 text-base sm:text-lg">{v.title}</h3>
              <p className="mt-2 text-slate-600 dark:text-slate-400 text-sm sm:text-base">{v.text}</p>
            </motion.div>
          ))}
          <div className="sm:col-span-2 lg:col-span-3 flex flex-wrap justify-center gap-4 sm:gap-6">
            {values.slice(3, 5).map((v, i) => (
              <motion.div
                key={v.title}
                className="group card-glass p-6 sm:p-8 relative overflow-hidden w-full min-w-0 lg:w-[calc(33.333%-1rem)] max-w-sm"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (3 + i) * 0.08, duration: 0.5 }}
                whileHover={{ y: -6 }}
              >
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-accent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: 'spring', stiffness: 400 }}
                >
                  <v.icon className="text-primary dark:text-accent" size={28} strokeWidth={1.8} />
                </motion.div>
                <h3 className="mt-4 font-semibold text-slate-800 dark:text-slate-100 text-base sm:text-lg">{v.title}</h3>
                <p className="mt-2 text-slate-600 dark:text-slate-400 text-sm sm:text-base">{v.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
